import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import tw from 'twin.macro';

export default styled(DatePicker)`
  && {
    ${tw`rounded p-3.5 outline-none bg-brand-u-secondary-color border-2 border-brand-u-secondary-border-color text-brand-u-secondary-text-color max-w-full`};
  }
`;
